export default __webpack_public_path__ + "static/media/twitter.b9f099b4.svg";